import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-game-vindow',
  templateUrl: './game-vindow.component.html',
  styleUrls: ['./game-vindow.component.css']
})
export class GameVindowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
